// CoverManager.js
var CoverManager = pc.createScript('coverManager');

CoverManager.attributes.add("posOne", {type: "entity"});
CoverManager.attributes.add("posTwo", {type: "entity"});
CoverManager.attributes.add("eventNum1", {type: "entity"});
CoverManager.attributes.add("eventNum2", {type: "entity"});
CoverManager.attributes.add("mathStatusIndicator", {type:"entity"});
CoverManager.attributes.add("matchObjectStatusBar", {type: "entity"});
CoverManager.attributes.add("minObjectLabel", {type: "entity"});
CoverManager.attributes.add("matchedObjectLabel", {type: "entity"});
CoverManager.attributes.add("wrongMatchIcon", {type: "entity"});
CoverManager.attributes.add("mathBarUI", {type: "entity"});
CoverManager.attributes.add("attentionBarUI", {type: "entity"});
CoverManager.attributes.add("wordBarUI", {type: "entity"});
CoverManager.attributes.add("linkBarUI", {type: "entity"});


CoverManager.prototype.initialize = function () {

    CoverManager.instance = this;
    this.log = new Log("COVER_MANAGER");

    this.objectOnTheCover = null;
    this.selectedObject1 = null;
    this.selectedObject2 = null;
    this.num1 = null;
    this.num2 = null;

    this.particleEntity = this.app.root.findByName('PARTICLE_Success_Match3D');
    spawnPositions = this.app.root.findByTag("spawnposition");
    this.animEntity = this.app.root.findByName("Cover");

    this.app.on('covermanager:entity',this.Placement,this);
    this.app.on('gameManager:updatestatus',this.Status,this);
    this.entity.collision.on('collisionstart', this.onCollisionStart, this);
    this.entity.on("destroy", this.OnDestroy,this);
};


CoverManager.prototype.updateMatchStatus = function(minimumObject, matched, visibility) {
  
    this.matchObjectStatusBar.enabled = visibility;
    matchObjectCounter = matched;
    this.minimumObjectNumber = minimumObject;
    this.minObjectLabel.element.text = minimumObject;
    this.matchedObjectLabel.element.text = matchObjectCounter;
};

CoverManager.prototype.ObjectStageTwo = function(entity, entity2) {

    this.app.fire('cover:stat', true);
    this.particleEntity.particlesystem.play();
    entity2.tween(entity2.getLocalPosition()).to({ x: 0, y: 0.5, z: 4 }, 0.15, pc.Linear).on('complete', function () { entity2.destroy(); }).start();
    entity.tween(entity.getLocalPosition()).to({ x: 0, y: 0.5, z: 4 }, 0.15, pc.Linear).on('complete', function () { CoverManager.instance.ObjectStageThree(entity); }).start();
};

CoverManager.prototype.ObjectStageThree = function (entity) {
    
    entity.tween(entity.getLocalScale()).to(new pc.Vec3(0.4, 0.4, 0.4), 0.15, pc.CubicInOut).on('complete', function () { CoverManager.instance.ObjectCheck(entity);}).start();
    this.particleEntity.particlesystem.reset();
};

CoverManager.prototype.Placement = function(refEntity) {
    
        var pos;

        if (spawnPositions[0].findByTag("dropped").length < 1) {
            
            SoundManager.instance.playSound('PlaceObject');
            this.objectOnTheCover = refEntity;
            
            if ((GameManager.instance.eventData.eventId == 1) && (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame)) {
                this.eventNum1.element.text=refEntity.tags.list()[1];
            }
            pos = new pc.Vec3(0.408,0,4.144);
            refEntity.tween(refEntity.getLocalEulerAngles()).rotate(CoverManager.instance.GetRotate(refEntity),0.3,pc.Linear).start();
            refEntity.tween(refEntity.getLocalPosition()).to(pos,0.2,pc.Linear).start();
            refEntity.rigidbody.enabled = false;
            refEntity.tags.add("dropped");
            this.selectedObject1 = refEntity.clone();
        }
        else {

            this.selectedObject2 = refEntity.clone();

            if (timer>0) {
                if (this.checkMatchPlacement(this.selectedObject1,this.selectedObject2)) {

                    let firstObjectOnCover = spawnPositions[0].findByTag('dropped')[0];
                    firstObjectOnCover.tags.remove("dropped");
                    SoundManager.instance.playSound('MergeObject');
                    refEntity.tags.add("untouchable");
                    matchObjectCounter++;
    
                    if (PlayerManager.instance.userData.gameMode != gamePlayMode.MiniGame) {
                        this.matchedObjectLabel.element.text = matchObjectCounter;
                        this.matchedObjectLabel.tween(this.matchedObjectLabel.getLocalScale()).to(new pc.Vec3(1.5, 1.5, 1), 0.5, pc.SineOut).yoyo(true).repeat(2).start();
                    }
                
                    if((PlayerManager.instance.userData.newPlayer === true) && (PlayerManager.instance.levelData.levelName == "Donut Shop")){
    
                        if (matchObjectCounter == 1) { Tutorial.instance.isCheckFactorTutorialStatus = true;}
                        if (isFactorTutorialCompleted === false) { Tutorial.instance.moveFactorTutorialOnOff(true);}
                    }
                    refEntity.rigidbody.enabled = false;
                    if (PlayerManager.instance.userData.gameMode != gamePlayMode.MiniGame) {
                        this.app.fire("Score:add");
                    }
                    
                    pos = new pc.Vec3(-0.272,0,4.144);
                    refEntity.tween(refEntity.getLocalEulerAngles()).rotate(CoverManager.instance.GetRotate(refEntity),0.2,pc.Linear).on('complete', function(){ CoverManager.instance.ObjectStageTwo(refEntity,firstObjectOnCover);}).start();
                    refEntity.tween(refEntity.getLocalPosition()).to(pos,0.15,pc.Linear).start();
    
                }
                else {
                    SoundManager.instance.playSound('WrongObject');
                    refEntity.rigidbody.teleport(refEntity.parent.getPosition().x, refEntity.parent.getPosition().y, refEntity.parent.getPosition().z);
                    refEntity.rigidbody.enabled = true;
                }
            }
            else {
                refEntity.rigidbody.teleport(refEntity.parent.getPosition().x, refEntity.parent.getPosition().y, refEntity.parent.getPosition().z);
                refEntity.rigidbody.enabled = true;
            }
        }
    
};

CoverManager.prototype.checkMatchPlacement = function(object1,object2) {
    
    let wrongSymbol = this.wrongMatchIcon;
    var returnVal;

    if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame) {
        
        if (GameManager.instance.eventData.eventId == 1) {
            let no1Txt = this.eventNum1.element;
            let no2Txt = this.eventNum2.element;
            
            var result;
            this.num1 = object1.tags.list()[1];
            this.num2 = object2.tags.list()[1];
            
            if (GameManager.instance.eventData.mathChallengeOperationKey == "addition") {
                result = parseInt(this.num1) + parseInt(this.num2);
            }
            else if (GameManager.instance.eventData.mathChallengeOperationKey == "subtraction") {
                result = parseInt(this.num1) - parseInt(this.num2);
            }
            else if (GameManager.instance.eventData.mathChallengeOperationKey == "multiplication") {
                result = parseInt(this.num1) * parseInt(this.num2);
            }
            else if (GameManager.instance.eventData.mathChallengeOperationKey == "division") {
                result = parseInt(this.num1) / parseInt(this.num2);
            }

            if (result === GameManager.instance.eventData.matchKey) {
                this.eventNum2.element.text = this.num2;
                this.mathStatusIndicator.tween(this.mathStatusIndicator.getLocalScale()).to(new pc.Vec3(1.5, 1.5, 1.5), 0.5, pc.SineOut).yoyo(true).repeat(2).on('complete', function () {  no1Txt.text = "_"; no2Txt.text = "_";}).start();
        
                returnVal = true;
            }
            else {
                this.eventNum1.element.text = "_";
                this.eventNum2.element.text = "_";
             
                this.wrongMatchIcon.enabled = true;
                this.wrongMatchIcon.tween(this.wrongMatchIcon.getLocalScale()).to(new pc.Vec3(1, 1, 1), 0.7, pc.SineOut).yoyo(true).repeat(2).on('complete', function () {  wrongSymbol.enabled = false;}).start();
                spawnPositions[0].findByTag('dropped')[0].rigidbody.teleport(spawnPositions[0].findByTag('dropped')[0].parent.getPosition().x,spawnPositions[0].findByTag('dropped')[0].parent.getPosition().y, spawnPositions[0].findByTag('dropped')[0].parent.getPosition().z);
                spawnPositions[0].findByTag('dropped')[0].rigidbody.enabled = true;
                spawnPositions[0].findByTag('dropped')[0].tags.remove("dropped");
                
                returnVal = false;
            }
        }
        else if (GameManager.instance.eventData.eventId == 2) {
            
            if (selectedWordKeys.includes(object2.tags.list()[1]) && object1.name === object2.name){
                EventsManager.instance.wordChallengeShowMatchLetters(object2.tags.list()[1]);
                returnVal = true;
            }
            else {
                this.wrongMatchIcon.enabled = true;
                this.wrongMatchIcon.tween(this.wrongMatchIcon.getLocalScale()).to(new pc.Vec3(1, 1, 1), 0.7, pc.SineOut).yoyo(true).repeat(2).on('complete', function () { wrongSymbol.enabled = false; }).start();
                spawnPositions[0].findByTag('dropped')[0].rigidbody.teleport(spawnPositions[0].findByTag('dropped')[0].parent.getPosition().x, spawnPositions[0].findByTag('dropped')[0].parent.getPosition().y, spawnPositions[0].findByTag('dropped')[0].parent.getPosition().z);
                spawnPositions[0].findByTag('dropped')[0].rigidbody.enabled = true;
                spawnPositions[0].findByTag('dropped')[0].tags.remove("dropped");

                returnVal = false;
            }
            
        }
        else if (GameManager.instance.eventData.eventId == 3 || GameManager.instance.eventData.eventId == 4 || GameManager.instance.eventData.eventId == 6) {
            
            if ((object1.name === object2.name) && this.checkExistObject(object2.name)) {
                if (GameManager.instance.eventData.eventId == 4) {
                    findByAttentionObjects.shift();

                    if (findByAttentionObjects.length >0) {
                        EventsManager.instance.attentionObjectUpdateStatus();
                    }
                }
                returnVal = true;
            }
            else {
                this.wrongMatchIcon.enabled = true;
                this.wrongMatchIcon.tween(this.wrongMatchIcon.getLocalScale()).to(new pc.Vec3(1, 1, 1), 0.7, pc.SineOut).yoyo(true).repeat(2).on('complete', function () {  wrongSymbol.enabled = false;}).start();
                spawnPositions[0].findByTag('dropped')[0].rigidbody.teleport(spawnPositions[0].findByTag('dropped')[0].parent.getPosition().x,spawnPositions[0].findByTag('dropped')[0].parent.getPosition().y, spawnPositions[0].findByTag('dropped')[0].parent.getPosition().z);
                spawnPositions[0].findByTag('dropped')[0].rigidbody.enabled = true;
                spawnPositions[0].findByTag('dropped')[0].tags.remove("dropped");

                returnVal = false;
            }
        }
    }
    else {
        
        if (object1.name === object2.name) {
            
            const index = roomObjectList.indexOf(object2.name);
            if (index > -1) {
                roomObjectList.splice(index, 1);
            }
            
            if((PlayerManager.instance.userData.newPlayer === true) && (PlayerManager.instance.levelData.levelName == "Donut Shop")){
                
                if (isFactorTutorialCompleted === false) {
                    Tutorial.instance.moveFactorTutorialOnOff(true);
                }
            }
            returnVal = true;
        }
        else {
            returnVal = false;
        }
    }
    return returnVal;
};


CoverManager.prototype.onCollisionStart = function(result) {
    this.Placement(result.other);
};

CoverManager.prototype.ObjectCounter = function() {

    var checkStatus = false;
    
    if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame) 
    {
        if (GameManager.instance.eventData.eventId == 1) {

            for (j = 0; j < spawnPositions[0].children.length; j++) {

                if (this.checkExistObject(parseInt(spawnPositions[0].children[j].tags.list()[1]))) {
                    checkStatus = true;
                    break;
                }    
            }

            if(checkStatus == false) {
                let mathUI = this.app.root.findByTag("mathPanel");
                mathUI[0].enabled = false;
            }

        }
        else if (GameManager.instance.eventData.eventId == 2) {

            if (cloneSelectedWordKeys.length>0) {
                checkStatus = true;
            }
            else {
                let wordUI = this.app.root.findByTag("wordPanel");
                wordUI[0].enabled = false;
                checkStatus = false;
            }
        }
    
        else if (GameManager.instance.eventData.eventId == 4) {
            
            if (findByAttentionObjects.length == 0) {
                let attentionUI = this.app.root.findByTag("attentionPanel");
                attentionUI[0].enabled = false;
                checkStatus = false;
            }
            else {
                checkStatus = true;
            }
        }
        
        else if (GameManager.instance.eventData.eventId == 6) {
            
            if (matchThemeAssetList.length == 0) {
                let linkUI = this.app.root.findByTag("linkPanel");
                linkUI[0].enabled = false;
                checkStatus = false;
            }
            else {
                checkStatus = true;
            }
        }
        
        if (!checkStatus) {
            SpawnManager.instance.clearObjects();
            Timer.instance.StopTimer();
            SoundManager.instance.playSound('WinSound');
            GameManager.instance.GameWin();
            //ADSManager.instance.OpenRewardVideo(adsEnum.Interstitial,adsGameFinishEnum.Win);
        }
    }
    else {

        if(spawnPositions[0].children.length === 0){
            SpawnManager.instance.clearObjects();
            Timer.instance.StopTimer();
            SoundManager.instance.playSound('WinSound');
            
            if (PlayerManager.instance.levelData.levelTemplate == "DonutShop") {
                GameManager.instance.GameWin();
                // ADSManager.instance.OpenRewardVideo(adsEnum.Interstitial,adsGameFinishEnum.Win);
            }
            else {
                completeMatchStatus = true;
                GameManager.instance.GameWin();
                //ADSManager.instance.OpenRewardVideo(adsEnum.Interstitial,adsGameFinishEnum.CompleteMatch);
            }
            
        }
    }
};

CoverManager.prototype.checkExistObject = function(object,operator){
       
    var selectedNo;
    var returnVal = false;

    if (GameManager.instance.eventData.eventId == 1) {

        for (i = 0; i < spawnPositions[0].children.length; i++) {

            selectedNo = parseInt(spawnPositions[0].children[i].tags.list()[1]);

            if (object == selectedNo) {
                returnVal = false;
                break;
            }
            else {
                if (GameManager.instance.eventData.mathChallengeOperationKey == "addition") {

                    if ((object + selectedNo) === GameManager.instance.eventData.matchKey) {
                        returnVal = true;
                        break;
                    }
                }
                else if (GameManager.instance.eventData.mathChallengeOperationKey == "subtraction") {

                    if (Math.abs(object - selectedNo) == GameManager.instance.eventData.matchKey) {
                        returnVal = true;
                        break;
                    }
                }
                else if (GameManager.instance.eventData.mathChallengeOperationKey == "multiplication") {

                    if ((object * selectedNo) == GameManager.instance.eventData.matchKey) {
                        returnVal = true;
                        break;
                    }
                }
                else if (GameManager.instance.eventData.mathChallengeOperationKey == "division") {

                    if ((object / selectedNo) == GameManager.instance.eventData.matchKey || (selectedNo / object) == GameManager.instance.eventData.matchKey) {
                        returnVal = true;
                        break;
                    }
                }
            }
        }
    }

    else if (GameManager.instance.eventData.eventId == 4) {

        let selectedAttentionIcon = this.app.assets.findByTag(findByAttentionObjects[0]);

        if (selectedAttentionIcon[0].id == object) {
            returnVal = true;
        }

    }
    else if (GameManager.instance.eventData.eventId == 6) {

        for (i=matchThemeAssetList.length-1; i>=0; i--) {

            if (matchThemeAssetList[i].id == object) {
                matchThemeAssetList.splice(i, 1); 
                returnVal = true;
            }
        }
    }
    return returnVal;
};

CoverManager.prototype.OnDestroy = function(){

    this.app.off('covermanager:entity',this.Placement,this);
    this.app.off('gameManager:updatestatus',this.Status,this);
    this.entity.off("destroy", this.OnDestroy,this);
};


CoverManager.prototype.ObjectCheck = function(entity) {

    this.app.fire('cover:stat', false);
    entity.destroy();
    this.ObjectCounter();
};

CoverManager.prototype.GetRotate = function(entity) {

    var rot;
    if (!entity.tags.has('return')) {
        rot = new pc.Vec3(0, 0, 0);
    }
    else {
        rot = new pc.Vec3(-90, 0, 0);
    }
    return rot;
};


